import React from "react";
import { SupplierVerificationPanel } from "./UserManagementPage";

export default function VerifikasiSupplierPage() {
  return (
    <div className="space-y-6" data-testid="verifikasi-supplier-page">
      <header>
        <div className="kedan-label text-slate-500">Manajemen</div>
        <h1 className="text-3xl font-display font-bold text-slate-900 mt-1">Verifikasi Supplier</h1>
        <p className="text-slate-500 text-sm mt-1">
          Kelola status verifikasi supplier pada sistem.
        </p>
      </header>
      <SupplierVerificationPanel />
    </div>
  );
}
